export const makeActionCreator =
  <A>() =>
  <T extends { type: A }>(d: T): T =>
    d;

// oxlint-disable-next-line typescript/no-explicit-any -- Required for Redux action creator system
type IActionCreatorMapObject = Record<string, (...args: any[]) => { type: string }>;

export type ActionsUnion<A extends IActionCreatorMapObject> = ReturnType<A[keyof A]>;
